module.exports = __webpack_public_path__ + "static/media/non-replicating-viral-vector.2f715997.jpg";